import React from 'react';

import ConfirmActionWarningModal from '../../../components/ConfirmActionWarningModal';
import StackedButtonGroup from '../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { hideModal, showModal } from '../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../redux/reducer';

const showDeleteTemplateModal = ({ e, dispatch }) => {
  e.preventDefault();
  e.stopPropagation();
  const templateId = Number(e.currentTarget.value);
  const description = 'This template will be permanently deleted from your account.';

  dispatch(globalRequirementTemplateBuilder.getRequirementTemplate(templateId));

  dispatch(showModal(
    () => <ConfirmActionWarningModal description={description} />,
    {
      title: 'Delete Template?',
      size: 'md',
      buttons: {
        component: StackedButtonGroup,
        primaryButtonOptions: {
          label: 'Delete',
          isDisabled: true,
          onClick: async () => {
            await dispatch(globalRequirementTemplateBuilder.deleteRequirementTemplate(templateId));
            dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
            dispatch(hideModal());
          }
        }
      }
    }
  ));
};

export default showDeleteTemplateModal;
